/* eslint-disable jsx-a11y/anchor-is-valid, jsx-a11y/img-redundant-alt */
import React from 'react';
import { Link } from 'react-router-dom';
import Tech from '../assets/service-1.jpg';
import Staffing from '../assets/service-2.jpg';
import Cloud from '../assets/service-3.jpg';
import AI from '../assets/service-4.jpg';
import Mobile from '../assets/service-5.jpg';
import App from '../assets/service-6.jpg';
import dot from '../assets/dot-arrow.png';
import Testimonial from '../components/Testimonial';
import Partners from '../components/Partners';

const Home = ({ onContactClick }) => {
  return (
    <div className="page-content active">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-container">
          <div className="hero-content">
            <h1>Building Digital <span class="hl-line">
              <span className="hl-word">
                <span className="accent-wrap">
                  <span className="accent">Excellence</span>
                </span>
              </span>
            </span>
              Through Innovation</h1>
            <p>Transform your business with cutting-edge IT solutions and skilled engineering talent. We deliver scalable applications and provide expert resources to accelerate your growth.</p>
            <div className="hero-buttons">
              <Link to="/portfolio" className="btn-primary">View Our Work</Link>
              <Link to="/jobs" className="btn-secondary">Explore Careers</Link>
            </div>
          </div>
          <div className="hero-visual">
            <div className="visual-card">
              <h3><i class="fa-solid fa-laptop-code" />Technology Solutions</h3>
              <p>Web & Mobile Development, Cloud Services, AI/ML Integration</p>
            </div>
            <div className="visual-card">
              <h3><i class="fa-solid fa-user-group" />IT Staffing</h3>
              <p>Skilled Engineers, Project-Based Teams, Long-term Resources</p>
            </div>
            <div className="visual-card">
              <h3><i class="fa-solid fa-bullhorn" />Digital Marketing</h3>
              <p>Skilled Engineers, Project-Based Teams, Long-term Resources</p>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats">
        <img className='img-1' src={dot} alt='element-1' />
        <div className="stats-container">
          <div data-aos="fade-up" data-aos-duration="1000" className="stat-item">
            <h3>2025</h3>
            <p>Founded</p>
          </div>
          <div data-aos="fade-up" data-aos-duration="2000" className="stat-item">
            <h3>10+</h3>
            <p>Specializations</p>
          </div>
          <div data-aos="fade-up" data-aos-duration="2000" className="stat-item">
            <h3>100%</h3>
            <p>Client Satisfaction</p>
          </div>
          <div data-aos="fade-up" data-aos-duration="2000" className="stat-item">
            <h3>24/7</h3>
            <p>Support Available</p>
          </div>
        </div>
        <img className='img-2' src={dot} alt='dot' />
      </section>

      {/* Services Section */}
      <section className="section" id="services">
        <div className="section-header">
          <div className="label">What We Do</div>
          <h2>Our Core Services</h2>
          <p>Comprehensive IT solutions and staffing services tailored to your business needs</p>
        </div>
        <div data-aos="fade-in" className="services-grid">
          <div className="service-card">
            <div className="service-icon">
              <img src={Tech} alt='technology development' />
            </div>
            <h3>Technology Development</h3>
            <p>Build modern, scalable web and mobile applications using cutting-edge technologies. From concept to deployment, we deliver solutions that drive business growth.</p>
            <div className="tech-tags">
              <span className="tech-tag">React</span>
              <span className="tech-tag">Node.js</span>
              <span className="tech-tag">AWS</span>
            </div>
          </div>
          <div className="service-card">
            <div className="service-icon">
              <img src={Staffing} alt='IT staffing' />
            </div>
            <h3>IT Staffing Solutions</h3>
            <p>Access skilled technology professionals who seamlessly integrate with your team. We provide dedicated resources for long-term engagements or project-specific needs.</p>
            <div className="tech-tags">
              <span className="tech-tag">Full-Stack</span>
              <span className="tech-tag">DevOps</span>
              <span className="tech-tag">AI/ML</span>
            </div>
          </div>
          <div className="service-card">
            <div className="service-icon">
              <img src={Cloud} alt='Cloud & infra' />
            </div>
            <h3>Cloud & Infrastructure</h3>
            <p>Modernize your infrastructure with AWS cloud services. We handle migration, optimization, and management to ensure reliability and scalability.</p>
            <div className="tech-tags">
              <span className="tech-tag">AWS</span>
              <span className="tech-tag">MongoDB</span>
              <span className="tech-tag">DevOps</span>
            </div>
          </div>
          <div className="service-card">
            <div className="service-icon">
              <img src={AI} alt='AI & ML' />
            </div>
            <h3>AI & Machine Learning</h3>
            <p>Leverage AI to automate processes and gain intelligent insights. We implement practical ML solutions that deliver measurable business value.</p>
            <div className="tech-tags">
              <span className="tech-tag">AI/ML</span>
              <span className="tech-tag">Python</span>
              <span className="tech-tag">TensorFlow</span>
            </div>
          </div>
          <div className="service-card">
            <div className="service-icon">
              <img src={Mobile} alt='Mobile App' />
            </div>
            <h3>Mobile App Development</h3>
            <p>Create exceptional mobile experiences with React Native. Build once, deploy everywhere with native performance and user experience.</p>
            <div className="tech-tags">
              <span className="tech-tag">React Native</span>
              <span className="tech-tag">iOS</span>
              <span className="tech-tag">Android</span>
            </div>
          </div>
          <div className="service-card">
            <div className="service-icon">
              <img src={App} alt='Application Modern' />
            </div>
            <h3>Application Modernization</h3>
            <p>Transform legacy systems into modern, efficient applications. We help you adopt contemporary architectures without disrupting operations.</p>
            <div className="tech-tags">
              <span className="tech-tag">Microservices</span>
              <span className="tech-tag">APIs</span>
              <span className="tech-tag">Cloud</span>
            </div>
          </div>
        </div>
      </section>
      <Partners />

      <Testimonial />

      {/* CTA Section */}
      <section class="cta-section">
        <h2>Ready to Transform Your Business?</h2>
        <p>Let's discuss how we can help you achieve your technology goals</p>
        <div class="hero-buttons justify">
          <a href="/" onclick="showPage('about')" class="btn-secondary">Learn More About Us</a>
          <a href="mailto:info@greenbucksengg.com" class="btn-primary get-touch">Get in Touch</a>
        </div>
      </section>
    </div>
  );
};

export default Home;
